import React from 'react';
import Circular from 'assets/images/icons/circular.gif';
import UtilHelper from 'util/UtilHelper.js';
const utilHelper = new UtilHelper();

function trimText(text, threshold) {
    if (!text) return 'N/A';
    if (text.length <= threshold) return text;
    return text.substr(0, threshold).concat('...');
}

function formatComparisonData(data) {
    if (data) {
        return data > 999
            ? '999+%'
            : data < -999
            ? '999+%'
            : data > 100
            ? `${Math.abs(Math.round(data))}%`
            : `${Math.abs(data)}%`;
    } else {
        return 'N/A';
    }
}

function Plane(props) {
    let data;
    let classCount = 0;
    let class1Names;
    let class2Names;
    let class3Names;
    let class4Names;
    let class1Data;
    let class2Data;
    let class3Data;
    let class4Data;
    let class1Change;
    let class2Change;
    let class3Change;
    let class4Change;
    let class1DataTitle;
    let class2DataTitle;
    let class3DataTitle;
    let class4DataTitle;

    if (props && props.data && props.data.length > 0) {
        // Remove 'PED' class from the plane data.
        data = props.data.filter((item) => item.label !== 'PED');

        data = data.length > 4 ? data.slice(0, 4) : data;
        classCount = data.length;
    }

    // Sample data for testing
    /*
    data =  [{
        "label": "First",
        "value": null,
        "comparison_value": null
    }, {
        "label": "Business",
        "value": "0",
        "comparison_value": "0"
    }, {
        "label": "Premium Economy",
        "value": "Sports",
        "comparison_value": "-10"
    }, {
        "label": "Economy",
        "value": "96",
        "comparison_value": "40"
    }
    ];
    classCount = data.length;
    */

    if (data) {
        if (classCount === 1) {
            if (data[0]) {
                class1Names = data[0].label.split(' ');
                class1Data = data[0].value;
                if (class1Data) {
                    if (props.unit === 'count') {
                        class1Data = utilHelper.formatToUnitsForPillBox(data[0].value);
                    } else if (props.unit === 'hr') {
                        class1Data =
                            props.text && props.text.includes('Total')
                                ? utilHelper.secondsToHmsForDynamicTabs(data[0].value)
                                : utilHelper.secondsToHoursMinutes(data[0].value);
                    } else if (props.unit === 'string') {
                        class1DataTitle = class1Data;
                        class1Data = trimText(class1Data, 9);
                    }
                } else {
                    class1Data = 'Data not available';
                }

                if (data[0].comparison_value) {
                    class1Change = data[0].comparison_value;
                }
            }
        } else if (classCount === 2) {
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    class1Names = data[i].label.split(' ');
                    class1Data = data[i].value;
                    if (class1Data) {
                        if (props.unit === 'count') {
                            class1Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class1Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class1DataTitle = class1Data;
                            class1Data = trimText(class1Data, 9);
                        }
                    } else {
                        class1Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class1Change = data[i].comparison_value;
                    }
                } else if (i === 1) {
                    class4Names = data[i].label.split(' ');
                    class4Data = data[i].value;
                    if (class4Data) {
                        if (props.unit === 'count') {
                            class4Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class4Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class4DataTitle = class4Data;
                            class4Data = trimText(class4Data, 9);
                        }
                    } else {
                        class4Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class4Change = data[i].comparison_value;
                    }
                }
            }
        } else if (classCount === 3) {
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    class1Names = data[i].label.split(' ');
                    class1Data = data[i].value;
                    if (class1Data) {
                        if (props.unit === 'count') {
                            class1Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class1Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class1DataTitle = class1Data;
                            class1Data = trimText(class1Data, 9);
                        }
                    } else {
                        class1Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class1Change = data[i].comparison_value;
                    }
                } else if (i === 1) {
                    class3Names = data[i].label.split(' ');
                    class3Data = data[i].value;
                    if (class3Data) {
                        if (props.unit === 'count') {
                            class3Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class3Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class3DataTitle = class3Data;
                            class3Data = trimText(class3Data, 9);
                        }
                    } else {
                        class3Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class3Change = data[i].comparison_value;
                    }
                } else if (i === 2) {
                    class4Names = data[i].label.split(' ');
                    class4Data = data[i].value;
                    if (class4Data) {
                        if (props.unit === 'count') {
                            class4Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class4Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class4DataTitle = class4Data;
                            class4Data = trimText(class4Data, 9);
                        }
                    } else {
                        class4Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class4Change = data[i].comparison_value;
                    }
                }
            }
        } else if (classCount === 4) {
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    class1Names = data[i].label.split(' ');
                    class1Data = data[i].value;
                    if (class1Data) {
                        if (props.unit === 'count') {
                            class1Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class1Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class1DataTitle = class1Data;
                            class1Data = trimText(class1Data, 9);
                        }
                    } else {
                        class1Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class1Change = data[i].comparison_value;
                    }
                } else if (i === 1) {
                    class2Names = data[i].label.split(' ');
                    class2Data = data[i].value;
                    if (class2Data) {
                        if (props.unit === 'count') {
                            class2Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class2Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class2DataTitle = class2Data;
                            class2Data = trimText(class2Data, 9);
                        }
                    } else {
                        class2Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class2Change = data[i].comparison_value;
                    }
                } else if (i === 2) {
                    class3Names = data[i].label.split(' ');
                    class3Data = data[i].value;
                    if (class3Data) {
                        if (props.unit === 'count') {
                            class3Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class3Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class3DataTitle = class3Data;
                            class3Data = trimText(class3Data, 9);
                        }
                    } else {
                        class3Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class3Change = data[i].comparison_value;
                    }
                } else if (i === 3) {
                    class4Names = data[i].label.split(' ');
                    class4Data = data[i].value;
                    if (class4Data) {
                        if (props.unit === 'count') {
                            class4Data = utilHelper.formatToUnitsForPillBox(data[i].value);
                        } else if (props.unit === 'hr') {
                            class4Data =
                                props.text && props.text.includes('Total')
                                    ? utilHelper.secondsToHmsForDynamicTabs(data[i].value)
                                    : utilHelper.secondsToHoursMinutes(data[i].value);
                        } else if (props.unit === 'string') {
                            class4DataTitle = class4Data;
                            class4Data = trimText(class4Data, 9);
                        }
                    } else {
                        class4Data = 'Data not available';
                    }

                    if (data[i].comparison_value) {
                        class4Change = data[i].comparison_value;
                    }
                }
            }
        }
    }

    let dataFontSize = props.unit === 'string' ? 22 : 27;

    //-----If loop to determine which aircraft to draw-----

    if (classCount === 0 && props.hasPED) {
        return (
            <svg
                width="1012px"
                height="294px"
                viewBox="0 0 1012 294"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <filter
                        x="-1.6%"
                        y="-5.9%"
                        width="103.2%"
                        height="111.9%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur
                            stdDeviation="2.5"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.301628059 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        ></feColorMatrix>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient
                        x1="-0.0282885431%"
                        y1="49.971193%"
                        x2="99.9717115%"
                        y2="49.971193%"
                        id="linearGradient-2"
                    >
                        <stop stopColor="#FFEBEE" offset="0%"></stop>
                        <stop stopColor="#EF9A9A" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%" y1="49.9265836%" x2="99.9496224%" y2="49.9265836%" id="linearGradient-3">
                        <stop stopColor="#EF9A9A" offset="0%"></stop>
                        <stop stopColor="#EF9A9A" offset="15.3381774%"></stop>
                        <stop stopColor="#E57373" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="7.03179136%"
                        y1="50.0056707%"
                        x2="99.9748299%"
                        y2="50.0056707%"
                        id="linearGradient-4"
                    >
                        <stop stopColor="#E57373" offset="0%"></stop>
                        <stop stopColor="#F44336" offset="43.4904939%"></stop>
                        <stop stopColor="#BB2217" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="-0.0251100413%"
                        y1="50.0014561%"
                        x2="100.000551%"
                        y2="50.0014561%"
                        id="linearGradient-5"
                    >
                        <stop stopColor="#BB2217" offset="0%"></stop>
                        <stop stopColor="#B32217" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-352.000000, -2029.000000)">
                        <g transform="translate(344.000000, 1885.000000)">
                            <g transform="translate(514.000000, 287.000000) scale(-1, 1) translate(-514.000000, -287.000000) translate(20.000000, 148.000000)">
                                <g filter="url(#filter-1)" transform="translate(0.000000, 8.000000)" fillRule="nonzero">
                                    <path
                                        d="M466.867893,140.4442 C437.143706,140.041781 407.023197,139.907642 378.620085,139.907642 C340.969448,139.907642 290.372277,139.102804 256.156436,139.505223 C256.420651,140.846619 189.97058,124.749863 184.818388,123.408466 C176.75983,121.262232 105.421782,22.6695987 93.7963225,10.5970313 C86.0019802,2.41451347 72.3949081,0 62.7510608,0 C57.202546,0 40.1606789,0.536558549 40.1606789,0.536558549 L90.0973126,148.492578 C84.8130127,148.894997 79.7929279,149.699835 74.772843,149.699835 C36.990099,138.968664 12.1538897,132.395822 9.64384724,132.395822 C2.64214993,132.395822 0,136.151732 0,136.151732 L68.5637907,162.040682 C70.2811881,172.503573 77.0186704,175.186366 95.1173975,182.295767 C113.216124,189.405168 255.363791,241.853766 303.847242,239.975811 C312.170014,239.707532 390.50976,242.256185 467,244 L467,140.4442 L466.867893,140.4442 Z"
                                        id="Path"
                                        fill="url(#linearGradient-2)"
                                    ></path>
                                    <path
                                        d="M640.867825,144.080997 C601.215257,143.277259 534.598943,141.803738 466,141 L466,244.41433 C482.918429,244.816199 499.836858,245.084112 515.83006,245.352025 C516.226586,247.76324 517.019637,250.040498 518.473565,250.844237 C529.179758,256.470405 539.225076,261.426791 539.225076,261.426791 C539.225076,262.23053 539.753776,263.034268 540.679003,263.302181 C546.494713,264.775701 569.625378,270 592.623867,270 C617.208459,270 631.747734,268.52648 641,267.05296 L641,144.080997 L640.867825,144.080997 Z"
                                        id="Path"
                                        fill="url(#linearGradient-3)"
                                    ></path>
                                    <path
                                        d="M666.777778,144.536532 C660.428571,144.402399 650.904762,144.268266 639,144 L639,267 C648.52381,265.524537 652.227513,263.91494 655.005291,263.91494 C665.322751,263.91494 666.777778,254.123228 666.380952,247.953108 C688.867725,247.953108 778.814815,249.428571 814,249.830971 L814,148.962923 C776.037037,146.280262 727.888889,144.536532 666.777778,144.536532 Z"
                                        id="Path"
                                        fill="url(#linearGradient-4)"
                                    ></path>
                                    <path
                                        d="M955.252531,188.787695 C953.009217,180.419117 941.924604,159.165585 813,150 L813,249.891597 C813.395879,249.891597 813.791758,249.891597 814.055677,249.891597 C847.969314,248.961755 914.476991,254.673641 961.850515,235.279794 C1011.99519,214.690436 978.741354,199.41446 955.252531,188.787695 Z"
                                        id="Path"
                                        fill="url(#linearGradient-5)"
                                    ></path>
                                </g>

                                <text
                                    fill="#A41F1E"
                                    transform="translate(953.000000, 36.000000) scale(-1, 1) translate(-953.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '936' : '933'} y="47">
                                        {''}
                                    </tspan>
                                </text>
                                <text
                                    fill="#A9201C"
                                    transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="921" y="78">
                                        {''}
                                    </tspan>
                                    <tspan x="921" y="103">
                                        {''}
                                    </tspan>
                                </text>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    } else if (classCount === 1) {
        return (
            <svg
                width="1012px"
                height="294px"
                viewBox="0 0 1012 294"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <filter
                        x="-1.6%"
                        y="-5.9%"
                        width="103.2%"
                        height="111.9%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur
                            stdDeviation="2.5"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.301628059 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        ></feColorMatrix>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient
                        x1="-0.0282885431%"
                        y1="49.971193%"
                        x2="99.9717115%"
                        y2="49.971193%"
                        id="linearGradient-2"
                    >
                        <stop stopColor="#FFEBEE" offset="0%"></stop>
                        <stop stopColor="#EF9A9A" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%" y1="49.9265836%" x2="99.9496224%" y2="49.9265836%" id="linearGradient-3">
                        <stop stopColor="#EF9A9A" offset="0%"></stop>
                        <stop stopColor="#EF9A9A" offset="15.3381774%"></stop>
                        <stop stopColor="#E57373" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="7.03179136%"
                        y1="50.0056707%"
                        x2="99.9748299%"
                        y2="50.0056707%"
                        id="linearGradient-4"
                    >
                        <stop stopColor="#E57373" offset="0%"></stop>
                        <stop stopColor="#F44336" offset="43.4904939%"></stop>
                        <stop stopColor="#BB2217" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="-0.0251100413%"
                        y1="50.0014561%"
                        x2="100.000551%"
                        y2="50.0014561%"
                        id="linearGradient-5"
                    >
                        <stop stopColor="#BB2217" offset="0%"></stop>
                        <stop stopColor="#B32217" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-352.000000, -2029.000000)">
                        <g transform="translate(344.000000, 1885.000000)">
                            <g transform="translate(514.000000, 287.000000) scale(-1, 1) translate(-514.000000, -287.000000) translate(20.000000, 148.000000)">
                                <g filter="url(#filter-1)" transform="translate(0.000000, 8.000000)" fillRule="nonzero">
                                    <path
                                        d="M466.867893,140.4442 C437.143706,140.041781 407.023197,139.907642 378.620085,139.907642 C340.969448,139.907642 290.372277,139.102804 256.156436,139.505223 C256.420651,140.846619 189.97058,124.749863 184.818388,123.408466 C176.75983,121.262232 105.421782,22.6695987 93.7963225,10.5970313 C86.0019802,2.41451347 72.3949081,0 62.7510608,0 C57.202546,0 40.1606789,0.536558549 40.1606789,0.536558549 L90.0973126,148.492578 C84.8130127,148.894997 79.7929279,149.699835 74.772843,149.699835 C36.990099,138.968664 12.1538897,132.395822 9.64384724,132.395822 C2.64214993,132.395822 0,136.151732 0,136.151732 L68.5637907,162.040682 C70.2811881,172.503573 77.0186704,175.186366 95.1173975,182.295767 C113.216124,189.405168 255.363791,241.853766 303.847242,239.975811 C312.170014,239.707532 390.50976,242.256185 467,244 L467,140.4442 L466.867893,140.4442 Z"
                                        id="Path"
                                        fill="url(#linearGradient-2)"
                                    ></path>
                                    <path
                                        d="M640.867825,144.080997 C601.215257,143.277259 534.598943,141.803738 466,141 L466,244.41433 C482.918429,244.816199 499.836858,245.084112 515.83006,245.352025 C516.226586,247.76324 517.019637,250.040498 518.473565,250.844237 C529.179758,256.470405 539.225076,261.426791 539.225076,261.426791 C539.225076,262.23053 539.753776,263.034268 540.679003,263.302181 C546.494713,264.775701 569.625378,270 592.623867,270 C617.208459,270 631.747734,268.52648 641,267.05296 L641,144.080997 L640.867825,144.080997 Z"
                                        id="Path"
                                        fill="url(#linearGradient-3)"
                                    ></path>
                                    <path
                                        d="M666.777778,144.536532 C660.428571,144.402399 650.904762,144.268266 639,144 L639,267 C648.52381,265.524537 652.227513,263.91494 655.005291,263.91494 C665.322751,263.91494 666.777778,254.123228 666.380952,247.953108 C688.867725,247.953108 778.814815,249.428571 814,249.830971 L814,148.962923 C776.037037,146.280262 727.888889,144.536532 666.777778,144.536532 Z"
                                        id="Path"
                                        fill="url(#linearGradient-4)"
                                    ></path>
                                    <path
                                        d="M955.252531,188.787695 C953.009217,180.419117 941.924604,159.165585 813,150 L813,249.891597 C813.395879,249.891597 813.791758,249.891597 814.055677,249.891597 C847.969314,248.961755 914.476991,254.673641 961.850515,235.279794 C1011.99519,214.690436 978.741354,199.41446 955.252531,188.787695 Z"
                                        id="Path"
                                        fill="url(#linearGradient-5)"
                                    ></path>
                                </g>

                                <text
                                    fill={class1Data === 'Data not available' ? '#7A7A7A' : '#A41F1E'}
                                    transform="translate(953.000000, 36.000000) scale(-1, 1) translate(-953.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class1Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '936' : '933'} y="47">
                                        {class1Data}
                                    </tspan>
                                    <title>{class1DataTitle}</title>
                                </text>
                                <text
                                    fill="#A9201C"
                                    transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="921" y="78">
                                        {class1Names[0]}
                                    </tspan>
                                    <tspan x="921" y="103">
                                        {class1Names[1]}
                                    </tspan>
                                </text>

                                {props.showWorkbenchLink && !isNaN(class1Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class1Change > 0 ? '#225522' : class1Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="921" y={class1Names.length === 2 ? 131 : 108}>
                                            {class1Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class1Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class1Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class1Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                <rect id="Rectangle" fill="#AF2119" x="986" y="7" width="2" height="215"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    } else if (classCount === 2) {
        return (
            <svg
                width="1012px"
                height="294px"
                viewBox="0 0 1012 294"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <filter
                        x="-1.6%"
                        y="-5.9%"
                        width="103.2%"
                        height="111.9%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur
                            stdDeviation="2.5"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.301628059 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        ></feColorMatrix>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient
                        x1="-0.0282885431%"
                        y1="49.971193%"
                        x2="99.9717115%"
                        y2="49.971193%"
                        id="linearGradient-2"
                    >
                        <stop stopColor="#91BCF3" offset="0%"></stop>
                        <stop stopColor="#85B0E6" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%" y1="49.9265836%" x2="99.9496224%" y2="49.9265836%" id="linearGradient-3">
                        <stop stopColor="#85B0E6" offset="0%"></stop>
                        <stop stopColor="#82ACE2" offset="15.3381774%"></stop>
                        <stop stopColor="#749DD2" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="7.03179136%"
                        y1="50.0056707%"
                        x2="99.9748299%"
                        y2="50.0056707%"
                        id="linearGradient-4"
                    >
                        <stop stopColor="#749ED2" offset="0%"></stop>
                        <stop stopColor="#5563A2" offset="43.4904939%"></stop>
                        <stop stopColor="#250759" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="-0.0251100413%"
                        y1="50.0014561%"
                        x2="100.000551%"
                        y2="50.0014561%"
                        id="linearGradient-5"
                    >
                        <stop stopColor="#26085A" offset="0%"></stop>
                        <stop stopColor="#B32217" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-352.000000, -2029.000000)">
                        <g transform="translate(344.000000, 1885.000000)">
                            <g transform="translate(514.000000, 287.000000) scale(-1, 1) translate(-514.000000, -287.000000) translate(20.000000, 148.000000)">
                                <g filter="url(#filter-1)" transform="translate(0.000000, 8.000000)" fillRule="nonzero">
                                    <path
                                        d="M466.867893,140.4442 C437.143706,140.041781 407.023197,139.907642 378.620085,139.907642 C340.969448,139.907642 290.372277,139.102804 256.156436,139.505223 C256.420651,140.846619 189.97058,124.749863 184.818388,123.408466 C176.75983,121.262232 105.421782,22.6695987 93.7963225,10.5970313 C86.0019802,2.41451347 72.3949081,0 62.7510608,0 C57.202546,0 40.1606789,0.536558549 40.1606789,0.536558549 L90.0973126,148.492578 C84.8130127,148.894997 79.7929279,149.699835 74.772843,149.699835 C36.990099,138.968664 12.1538897,132.395822 9.64384724,132.395822 C2.64214993,132.395822 0,136.151732 0,136.151732 L68.5637907,162.040682 C70.2811881,172.503573 77.0186704,175.186366 95.1173975,182.295767 C113.216124,189.405168 255.363791,241.853766 303.847242,239.975811 C312.170014,239.707532 390.50976,242.256185 467,244 L467,140.4442 L466.867893,140.4442 Z"
                                        id="Path"
                                        fill="url(#linearGradient-2)"
                                    ></path>
                                    <path
                                        d="M640.867825,144.080997 C601.215257,143.277259 534.598943,141.803738 466,141 L466,244.41433 C482.918429,244.816199 499.836858,245.084112 515.83006,245.352025 C516.226586,247.76324 517.019637,250.040498 518.473565,250.844237 C529.179758,256.470405 539.225076,261.426791 539.225076,261.426791 C539.225076,262.23053 539.753776,263.034268 540.679003,263.302181 C546.494713,264.775701 569.625378,270 592.623867,270 C617.208459,270 631.747734,268.52648 641,267.05296 L641,144.080997 L640.867825,144.080997 Z"
                                        id="Path"
                                        fill="url(#linearGradient-3)"
                                    ></path>
                                    <path
                                        d="M666.777778,144.536532 C660.428571,144.402399 650.904762,144.268266 639,144 L639,267 C648.52381,265.524537 652.227513,263.91494 655.005291,263.91494 C665.322751,263.91494 666.777778,254.123228 666.380952,247.953108 C688.867725,247.953108 778.814815,249.428571 814,249.830971 L814,148.962923 C776.037037,146.280262 727.888889,144.536532 666.777778,144.536532 Z"
                                        id="Path"
                                        fill="url(#linearGradient-4)"
                                    ></path>
                                    <path
                                        d="M955.252531,188.787695 C953.009217,180.419117 941.924604,159.165585 813,150 L813,249.891597 C813.395879,249.891597 813.791758,249.891597 814.055677,249.891597 C847.969314,248.961755 914.476991,254.673641 961.850515,235.279794 C1011.99519,214.690436 978.741354,199.41446 955.252531,188.787695 Z"
                                        id="Path"
                                        fill="url(#linearGradient-5)"
                                    ></path>
                                </g>
                                <text
                                    fill={class4Data === 'Data not available' ? '#7A7A7A' : '#26095A'}
                                    transform="translate(764.000000, 36.000000) scale(-1, 1) translate(-764.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class4Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '729' : '726'} y="47">
                                        {class4Data}
                                    </tspan>
                                    <title>{class4DataTitle}</title>
                                </text>
                                <text
                                    fill="#26095A"
                                    transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="698" y="78">
                                        {class4Names[0]}
                                    </tspan>
                                    <tspan x="698" y="103">
                                        {class4Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class1Data === 'Data not available' ? '#7A7A7A' : '#A41F1E'}
                                    transform="translate(953.000000, 36.000000) scale(-1, 1) translate(-953.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class1Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '936' : '933'} y="47">
                                        {class1Data}
                                    </tspan>
                                    <title>{class1DataTitle}</title>
                                </text>
                                <text
                                    fill="#A9201C"
                                    transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="918" y="78">
                                        {class1Names[0]}
                                    </tspan>
                                    <tspan x="918" y="103">
                                        {class1Names[1]}
                                    </tspan>
                                </text>

                                {props.showWorkbenchLink && !isNaN(class4Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class4Change > 0 ? '#225522' : class4Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="698" y={class4Names.length === 2 ? 131 : 108}>
                                            {class4Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class4Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class4Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class4Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class1Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class1Change > 0 ? '#225522' : class1Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="918" y={class1Names.length === 2 ? 131 : 108}>
                                            {class1Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class1Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class1Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class1Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                <rect id="Rectangle" fill="#AF2119" x="986" y="7" width="2" height="215"></rect>
                                <rect id="Rectangle" fill="#26085A" x="814" y="7" width="2" height="151"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    } else if (classCount === 3) {
        return (
            <svg
                width="1012px"
                height="294px"
                viewBox="0 0 1012 294"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <filter
                        x="-1.6%"
                        y="-5.9%"
                        width="103.2%"
                        height="111.9%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur
                            stdDeviation="2.5"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.301628059 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        ></feColorMatrix>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient
                        x1="-0.0282885431%"
                        y1="49.971193%"
                        x2="99.9717115%"
                        y2="49.971193%"
                        id="linearGradient-2"
                    >
                        <stop stopColor="#98C5FF" offset="0%"></stop>
                        <stop stopColor="#87B2EB" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%" y1="49.9265836%" x2="99.9496224%" y2="49.9265836%" id="linearGradient-3">
                        <stop stopColor="#87B2EB" offset="0%"></stop>
                        <stop stopColor="#80ABE3" offset="15.3381774%"></stop>
                        <stop stopColor="#749DD2" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="7.03179136%"
                        y1="50.0056707%"
                        x2="99.9748299%"
                        y2="50.0056707%"
                        id="linearGradient-4"
                    >
                        <stop stopColor="#749ED2" offset="0%"></stop>
                        <stop stopColor="#5563A2" offset="43.4904939%"></stop>
                        <stop stopColor="#250759" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="-0.0251100413%"
                        y1="50.0014561%"
                        x2="100.000551%"
                        y2="50.0014561%"
                        id="linearGradient-5"
                    >
                        <stop stopColor="#26085A" offset="0%"></stop>
                        <stop stopColor="#B32217" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-352.000000, -2029.000000)">
                        <g transform="translate(344.000000, 1885.000000)">
                            <g transform="translate(514.000000, 287.000000) scale(-1, 1) translate(-514.000000, -287.000000) translate(20.000000, 148.000000)">
                                <g filter="url(#filter-1)" transform="translate(0.000000, 8.000000)" fillRule="nonzero">
                                    <path
                                        d="M466.867893,140.4442 C437.143706,140.041781 407.023197,139.907642 378.620085,139.907642 C340.969448,139.907642 290.372277,139.102804 256.156436,139.505223 C256.420651,140.846619 189.97058,124.749863 184.818388,123.408466 C176.75983,121.262232 105.421782,22.6695987 93.7963225,10.5970313 C86.0019802,2.41451347 72.3949081,0 62.7510608,0 C57.202546,0 40.1606789,0.536558549 40.1606789,0.536558549 L90.0973126,148.492578 C84.8130127,148.894997 79.7929279,149.699835 74.772843,149.699835 C36.990099,138.968664 12.1538897,132.395822 9.64384724,132.395822 C2.64214993,132.395822 0,136.151732 0,136.151732 L68.5637907,162.040682 C70.2811881,172.503573 77.0186704,175.186366 95.1173975,182.295767 C113.216124,189.405168 255.363791,241.853766 303.847242,239.975811 C312.170014,239.707532 390.50976,242.256185 467,244 L467,140.4442 L466.867893,140.4442 Z"
                                        id="Path"
                                        fill="url(#linearGradient-2)"
                                    ></path>
                                    <path
                                        d="M640.867825,144.080997 C601.215257,143.277259 534.598943,141.803738 466,141 L466,244.41433 C482.918429,244.816199 499.836858,245.084112 515.83006,245.352025 C516.226586,247.76324 517.019637,250.040498 518.473565,250.844237 C529.179758,256.470405 539.225076,261.426791 539.225076,261.426791 C539.225076,262.23053 539.753776,263.034268 540.679003,263.302181 C546.494713,264.775701 569.625378,270 592.623867,270 C617.208459,270 631.747734,268.52648 641,267.05296 L641,144.080997 L640.867825,144.080997 Z"
                                        id="Path"
                                        fill="url(#linearGradient-3)"
                                    ></path>
                                    <path
                                        d="M666.777778,144.536532 C660.428571,144.402399 650.904762,144.268266 639,144 L639,267 C648.52381,265.524537 652.227513,263.91494 655.005291,263.91494 C665.322751,263.91494 666.777778,254.123228 666.380952,247.953108 C688.867725,247.953108 778.814815,249.428571 814,249.830971 L814,148.962923 C776.037037,146.280262 727.888889,144.536532 666.777778,144.536532 Z"
                                        id="Path"
                                        fill="url(#linearGradient-4)"
                                    ></path>
                                    <path
                                        d="M955.252531,188.787695 C953.009217,180.419117 941.924604,159.165585 813,150 L813,249.891597 C813.395879,249.891597 813.791758,249.891597 814.055677,249.891597 C847.969314,248.961755 914.476991,254.673641 961.850515,235.279794 C1011.99519,214.690436 978.741354,199.41446 955.252531,188.787695 Z"
                                        id="Path"
                                        fill="url(#linearGradient-5)"
                                    ></path>
                                </g>
                                <text
                                    fill={class4Data === 'Data not available' ? '#7A7A7A' : '#75A0D3'}
                                    transform="translate(592.000000, 29.000000) scale(-1, 1) translate(-592.000000, -29.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class4Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '560' : '562'} y="47">
                                        {class4Data}
                                    </tspan>
                                    <title>{class4DataTitle}</title>
                                </text>
                                <text
                                    fill="#75A0D3"
                                    transform="translate(576.500000, 82.000000) scale(-1, 1) translate(-576.500000, -82.000000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="531" y="78">
                                        {class4Names[0]}
                                    </tspan>
                                    <tspan x="531" y="103">
                                        {class4Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class3Data === 'Data not available' ? '#7A7A7A' : '#26095A'}
                                    transform="translate(764.000000, 36.000000) scale(-1, 1) translate(-764.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class3Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '729' : '726'} y="47">
                                        {class3Data}
                                    </tspan>
                                    <title>{class3DataTitle}</title>
                                </text>
                                <text
                                    fill="#26095A"
                                    transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="698" y="78">
                                        {class3Names[0]}
                                    </tspan>
                                    <tspan x="698" y="103">
                                        {class3Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class1Data === 'Data not available' ? '#7A7A7A' : '#A41F1E'}
                                    transform="translate(953.000000, 36.000000) scale(-1, 1) translate(-953.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class1Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '936' : '933'} y="47">
                                        {class1Data}
                                    </tspan>
                                    <title>{class1DataTitle}</title>
                                </text>
                                <text
                                    fill="#A9201C"
                                    transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="918" y="78">
                                        {class1Names[0]}
                                    </tspan>
                                    <tspan x="918" y="103">
                                        {class1Names[1]}
                                    </tspan>
                                </text>

                                {props.showWorkbenchLink && !isNaN(class4Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(576.500000, 82.000000) scale(-1, 1) translate(-576.500000, -82.000000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class4Change > 0 ? '#225522' : class4Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="531" y={class4Names.length === 2 ? 131 : 108}>
                                            {class4Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class4Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class4Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class4Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class3Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class3Change > 0 ? '#225522' : class3Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="698" y={class3Names.length === 2 ? 131 : 108}>
                                            {class3Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class3Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class3Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class3Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class1Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class1Change > 0 ? '#225522' : class1Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="918" y={class1Names.length === 2 ? 131 : 108}>
                                            {class1Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class1Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class1Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class1Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                <rect id="Rectangle" fill="#AF2119" x="986" y="7" width="2" height="215"></rect>
                                <rect id="Rectangle" fill="#26085A" x="814" y="7" width="2" height="151"></rect>
                                <rect id="Rectangle" fill="#61A1D6" x="630" y="7" width="2" height="145"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    } else if (classCount === 4) {
        return (
            <svg
                width="1012px"
                height="294px"
                viewBox="0 0 1012 294"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlnsXlink="http://www.w3.org/1999/xlink"
            >
                <defs>
                    <filter
                        x="-1.6%"
                        y="-5.9%"
                        width="103.2%"
                        height="111.9%"
                        filterUnits="objectBoundingBox"
                        id="filter-1"
                    >
                        <feOffset dx="3" dy="3" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
                        <feGaussianBlur
                            stdDeviation="2.5"
                            in="shadowOffsetOuter1"
                            result="shadowBlurOuter1"
                        ></feGaussianBlur>
                        <feColorMatrix
                            values="0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.301628059 0"
                            type="matrix"
                            in="shadowBlurOuter1"
                            result="shadowMatrixOuter1"
                        ></feColorMatrix>
                        <feMerge>
                            <feMergeNode in="shadowMatrixOuter1"></feMergeNode>
                            <feMergeNode in="SourceGraphic"></feMergeNode>
                        </feMerge>
                    </filter>
                    <linearGradient
                        x1="-0.0282885431%"
                        y1="49.971193%"
                        x2="99.9717115%"
                        y2="49.971193%"
                        id="linearGradient-2"
                    >
                        <stop stopColor="#8AD4E0" offset="0%"></stop>
                        <stop stopColor="#8AD4E0" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient x1="0%" y1="49.9265836%" x2="99.9496224%" y2="49.9265836%" id="linearGradient-3">
                        <stop stopColor="#8AD4E0" offset="0%"></stop>
                        <stop stopColor="#84C6DC" offset="15.3381774%"></stop>
                        <stop stopColor="#749DD2" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="7.03179136%"
                        y1="50.0056707%"
                        x2="99.9748299%"
                        y2="50.0056707%"
                        id="linearGradient-4"
                    >
                        <stop stopColor="#749ED2" offset="0%"></stop>
                        <stop stopColor="#5563A2" offset="43.4904939%"></stop>
                        <stop stopColor="#250759" offset="100%"></stop>
                    </linearGradient>
                    <linearGradient
                        x1="-0.0251100413%"
                        y1="50.0014561%"
                        x2="100.000551%"
                        y2="50.0014561%"
                        id="linearGradient-5"
                    >
                        <stop stopColor="#26085A" offset="0%"></stop>
                        <stop stopColor="#B32217" offset="100%"></stop>
                    </linearGradient>
                </defs>
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(-352.000000, -2029.000000)">
                        <g transform="translate(344.000000, 1885.000000)">
                            <g transform="translate(514.000000, 287.000000) scale(-1, 1) translate(-514.000000, -287.000000) translate(20.000000, 148.000000)">
                                <g filter="url(#filter-1)" transform="translate(0.000000, 8.000000)" fillRule="nonzero">
                                    <path
                                        d="M466.867893,140.4442 C437.143706,140.041781 407.023197,139.907642 378.620085,139.907642 C340.969448,139.907642 290.372277,139.102804 256.156436,139.505223 C256.420651,140.846619 189.97058,124.749863 184.818388,123.408466 C176.75983,121.262232 105.421782,22.6695987 93.7963225,10.5970313 C86.0019802,2.41451347 72.3949081,0 62.7510608,0 C57.202546,0 40.1606789,0.536558549 40.1606789,0.536558549 L90.0973126,148.492578 C84.8130127,148.894997 79.7929279,149.699835 74.772843,149.699835 C36.990099,138.968664 12.1538897,132.395822 9.64384724,132.395822 C2.64214993,132.395822 0,136.151732 0,136.151732 L68.5637907,162.040682 C70.2811881,172.503573 77.0186704,175.186366 95.1173975,182.295767 C113.216124,189.405168 255.363791,241.853766 303.847242,239.975811 C312.170014,239.707532 390.50976,242.256185 467,244 L467,140.4442 L466.867893,140.4442 Z"
                                        id="Path"
                                        fill="url(#linearGradient-2)"
                                    ></path>
                                    <path
                                        d="M640.867825,144.080997 C601.215257,143.277259 534.598943,141.803738 466,141 L466,244.41433 C482.918429,244.816199 499.836858,245.084112 515.83006,245.352025 C516.226586,247.76324 517.019637,250.040498 518.473565,250.844237 C529.179758,256.470405 539.225076,261.426791 539.225076,261.426791 C539.225076,262.23053 539.753776,263.034268 540.679003,263.302181 C546.494713,264.775701 569.625378,270 592.623867,270 C617.208459,270 631.747734,268.52648 641,267.05296 L641,144.080997 L640.867825,144.080997 Z"
                                        id="Path"
                                        fill="url(#linearGradient-3)"
                                    ></path>
                                    <path
                                        d="M666.777778,144.536532 C660.428571,144.402399 650.904762,144.268266 639,144 L639,267 C648.52381,265.524537 652.227513,263.91494 655.005291,263.91494 C665.322751,263.91494 666.777778,254.123228 666.380952,247.953108 C688.867725,247.953108 778.814815,249.428571 814,249.830971 L814,148.962923 C776.037037,146.280262 727.888889,144.536532 666.777778,144.536532 Z"
                                        id="Path"
                                        fill="url(#linearGradient-4)"
                                    ></path>
                                    <path
                                        d="M955.252531,188.787695 C953.009217,180.419117 941.924604,159.165585 813,150 L813,249.891597 C813.395879,249.891597 813.791758,249.891597 814.055677,249.891597 C847.969314,248.961755 914.476991,254.673641 961.850515,235.279794 C1011.99519,214.690436 978.741354,199.41446 955.252531,188.787695 Z"
                                        id="Path"
                                        fill="url(#linearGradient-5)"
                                    ></path>
                                </g>

                                <text
                                    fill={class4Data === 'Data not available' ? '#7A7A7A' : '#6EC4C2'}
                                    transform="translate(415.000000, 36.000000) scale(-1, 1) translate(-415.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class4Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x="390" y="47">
                                        {class4Data}
                                    </tspan>
                                    <title>{class4DataTitle}</title>
                                </text>
                                <text
                                    fill="#6EC4C2"
                                    transform="translate(397.500000, 74.500000) scale(-1, 1) translate(-397.500000, -74.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="355" y="78">
                                        {class4Names[0]}
                                    </tspan>
                                    <tspan x="355" y="103">
                                        {class4Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class3Data === 'Data not available' ? '#7A7A7A' : '#75A0D3'}
                                    transform="translate(592.000000, 29.000000) scale(-1, 1) translate(-592.000000, -29.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class3Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '560' : '562'} y="47">
                                        {class3Data}
                                    </tspan>
                                    <title>{class3DataTitle}</title>
                                </text>
                                <text
                                    fill="#75A0D3"
                                    transform="translate(576.500000, 82.000000) scale(-1, 1) translate(-576.500000, -82.000000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="531" y="78">
                                        {class3Names[0]}
                                    </tspan>
                                    <tspan x="531" y="103">
                                        {class3Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class2Data === 'Data not available' ? '#7A7A7A' : '#26095A'}
                                    transform="translate(764.000000, 36.000000) scale(-1, 1) translate(-764.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class2Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '729' : '726'} y="47">
                                        {class2Data}
                                    </tspan>
                                    <title>{class2DataTitle}</title>
                                </text>
                                <text
                                    fill="#26095A"
                                    transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="698" y="78">
                                        {class2Names[0]}
                                    </tspan>
                                    <tspan x="698" y="103">
                                        {class2Names[1]}
                                    </tspan>
                                </text>

                                <text
                                    fill={class1Data === 'Data not available' ? '#7A7A7A' : '#A41F1E'}
                                    transform="translate(953.000000, 36.000000) scale(-1, 1) translate(-953.000000, -36.000000)"
                                    fontFamily="Helvetica"
                                    fontSize={class1Data === 'Data not available' ? 18 : dataFontSize}
                                    fontWeight="normal"
                                >
                                    <tspan x={props.unit === 'string' ? '936' : '933'} y="47">
                                        {class1Data}
                                    </tspan>
                                    <title>{class1DataTitle}</title>
                                </text>
                                <text
                                    fill="#A9201C"
                                    transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                    fontFamily="Helvetica-Bold, Helvetica"
                                    fontSize="21"
                                    fontWeight="bold"
                                >
                                    <tspan x="918" y="78">
                                        {class1Names[0]}
                                    </tspan>
                                    <tspan x="918" y="103">
                                        {class1Names[1]}
                                    </tspan>
                                </text>

                                {props.showWorkbenchLink && !isNaN(class4Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(397.500000, 74.500000) scale(-1, 1) translate(-397.500000, -74.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class4Change > 0 ? '#225522' : class4Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="351" y={class4Names.length === 2 ? 131 : 108}>
                                            {class4Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class4Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class4Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class4Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class3Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(576.500000, 82.000000) scale(-1, 1) translate(-576.500000, -82.000000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class3Change > 0 ? '#225522' : class3Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="531" y={class3Names.length === 2 ? 131 : 108}>
                                            {class3Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class3Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class3Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class3Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class2Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(749.500000, 77.500000) scale(-1, 1) translate(-749.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class2Change > 0 ? '#225522' : class2Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="698" y={class2Names.length === 2 ? 131 : 108}>
                                            {class2Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class2Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class2Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class2Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                {props.showWorkbenchLink && !isNaN(class1Change) ? (
                                    <text
                                        fontFamily="Inter regular, sans-serif"
                                        transform="translate(945.500000, 77.500000) scale(-1, 1) translate(-945.500000, -77.500000)"
                                        fontSize="14"
                                        fontWeight="normal"
                                        line-spacing="20"
                                        letterSpacing="0.1"
                                        fill={class1Change > 0 ? '#225522' : class1Change < 0 ? '#FF0000' : '#9E9E9E'}
                                    >
                                        <tspan x="918" y={class1Names.length === 2 ? 131 : 108}>
                                            {class1Change > 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25B2 '}
                                                </tspan>
                                            ) : class1Change < 0 ? (
                                                <tspan width="47" height="20" fontSize="13.4">
                                                    {'\u25BC '}
                                                </tspan>
                                            ) : class1Change === 0 ? (
                                                <tspan width="47" height="20" fontSize="15">
                                                    <i className="fas fa-sort" style={{ fontSize: '15px' }}></i>
                                                </tspan>
                                            ) : (
                                                ''
                                            )}
                                            {formatComparisonData(class1Change)}
                                        </tspan>
                                    </text>
                                ) : (
                                    ''
                                )}

                                <rect id="Rectangle" fill="#6EC4C2" x="450" y="7" width="2" height="142"></rect>
                                <rect id="Rectangle" fill="#AF2119" x="986" y="7" width="2" height="215"></rect>
                                <rect id="Rectangle" fill="#26085A" x="814" y="7" width="2" height="151"></rect>
                                <rect id="Rectangle" fill="#61A1D6" x="630" y="7" width="2" height="145"></rect>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        );
    } else {
        return (
            <div style={{ width: '100%', height: '300px' }}>
                {props.loading && (
                    <div>
                        <div className="data-wrapper custom-loading" style={{ marginTop: '10%' }}>
                            <img src={Circular} alt="" />
                        </div>
                    </div>
                )}
                {!props.loading && (
                    <div>
                        <div className="no-data" style={{ top: '30%', fontSize: '26px' }}>
                            Data is not available
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

export default Plane;
